/**
 * 한국어 원문 → 핀란드어 사전. 키 규칙과 폴백(→영어→한국어)은 en.js·index.js 참고.
 * 이 파일은 번역 TSV 에서 생성했다. 원문 문구를 바꾸면 en.js 와 함께 키를 고쳐야 한다.
 */
const fi = {
    "지도 보러가기": "Avaa kartta",
    "서비스 바로가기": "Palvelumme",
    "언어 선택": "Valitse kieli",
    "PROPMATE 지도": "PROPMATE-kartta",
    "토지 정보·건축 가능 규모·공사비를 지도에서 확인": "Tonttitiedot, rakennusoikeus ja rakennuskustannukset kartalla",
    "Madang": "Madang",
    "대지 분석부터 매스·평면까지 AI 건축 설계": "Tekoälyavusteinen arkkitehtisuunnittelu – tonttianalyysista massoitteluun ja pohjapiirroksiin",
    "{name} 화면 미리보기": "Esikatselu: {name}",
    "3D 웹사이트 보러가기": "Siirry 3D-sivustolle",
    "컨설팅 받아보기": "Pyydä neuvontaa",
    "로그인 후 이용가능합니다.": "Kirjaudu sisään käyttääksesi tätä toimintoa.",
    "프롭메이트 로고": "PROPMATE-logo",
    "집을 짓는 새로운 방식, 프롭메이트": "Uusi tapa rakentaa. PROPMATE.",
    "오직 당신만을 위한 최적화된 디자인": "Juuri sinulle optimoitu suunnittelu",
    "단 하나의 디자인을 만들어 냅니다. 고객 만족을 최우선으로한 프롭메이트만의 디자인을 체험해보세요.": "Luomme yhden ainoan suunnitelman – juuri sinulle. Koe suunnittelu, jossa tyytyväisyytesi on etusijalla.",
    "엄선된 전문 업체로 최상의 시공성": "Huolella valitut asiantuntijat, huippuluokan rakentaminen",
    "다양한 포트폴리오를 가진 최고의 업체와 함께합니다. 그들의 작품을 감상해보세요.": "Teemme yhteistyötä alan johtavien yritysten kanssa, joilla on laajat referenssit. Tutustu heidän töihinsä.",
    "고객 예산에 맞춘 금융 컨설팅": "Rahoitusneuvontaa budjettisi mukaan",
    "고객 예산안에 최적화된 자금 활용 방안을 확인해보세요. 언제든 상담해 드립니다.": "Löydä paras tapa käyttää budjettisi. Neuvomme sinua milloin tahansa.",
    "고객 예산 안에 최적화된 자금 활용 방안을 확인해보세요. 언제든 상담해 드립니다.": "Löydä paras tapa käyttää budjettisi. Neuvomme sinua milloin tahansa.",
    "지도 기반 토지정보 확인 시스템": "Karttapohjainen tonttitietojärjestelmä",
    "원하는 땅을 찾아보세요": "Löydä etsimäsi tontti",
    "원하는 땅을 찾아보세요.": "Löydä etsimäsi tontti.",
    "얼마에 어떤 건물을 지을 수 있는지 직접 확인하세요.": "Näe itse, mitä voit rakentaa ja millä kustannuksin.",
    "언제 어디서나, 3D Viewer": "Missä ja milloin tahansa – 3D-katselin",
    "언제 어디서나, 3D Veiwer": "Missä ja milloin tahansa – 3D-katselin",
    "Web기반의 3D뷰어로,": "Verkkopohjaisella 3D-katselimella",
    "언제 어디서나 여러분의 계획안을 직관적으로 확인하세요.": "näet suunnitelmasi yhdellä silmäyksellä, missä ikinä oletkin.",
    "집 짓는데 필요한 필수 정보 컨설팅": "Neuvontaa kaikesta, mitä rakentamiseen tarvitaan",
    "집을 짓기에 필요한 수많은 궁금증": "Rakentaminen herättää paljon kysymyksiä –",
    "언제든 물어보고 결정하세요.": "kysy milloin tahansa ja päätä sitten.",
    "언제 어디서나,": "Missä ja milloin tahansa –",
    "집 짓는데 필요한": "Neuvontaa kaikesta,",
    "필수 정보 컨설팅": "mitä rakentamiseen tarvitaan",
    "확인 시스템": "yhdellä silmäyksellä",
    "지도 기반 토지정보": "Karttapohjaiset tonttitiedot",
    "원하는 땅을 직접 찾아보세요.": "Etsi haluamasi tontti itse.",
    "토지가 가진 토지 이용 규제정보, 각종 법령 정보를": "Maankäytön rajoitukset ja tonttia koskevat säädökset",
    "종합하여 클릭만으로 쉽게 확인해볼 수 있습니다.": "kootaan yhteen, joten näet kaiken yhdellä klikkauksella.",
    "대한민국 어디든 원하는 땅을 찾아,": "Valitse mikä tahansa tontti Etelä-Koreasta",
    "땅이 가진 정보를 눈으로 확인해 보세요.": "ja näe omin silmin, mitä se pitää sisällään.",
    "원하는 토지에 어떤 건축물을 지을 수 있는지,": "Mitä sille saa rakentaa,",
    "어느 정도 규모의 건물을 건축할 수 있는지,": "kuinka suuri rakennus voi olla,",
    "해당 크기의 건축을 하려면 어느 정도의 비용이 소요되는지,": "mitä sen rakentaminen maksaisi",
    "초기 건축 자본은 얼마가 필요한지 등을": "ja kuinka paljon alkupääomaa tarvitset –",
    "여러분이 직접 확인하시고 건축하세요!": "tarkista kaikki itse ja rakenna sitten.",
    "언제 어디서나, 3D 뷰어": "Missä ja milloin tahansa – 3D-katselin",
    "설계한 건축물을 3차원 공간에서 체험하세요.": "Koe suunnitelmasi kolmessa ulottuvuudessa.",
    "어려운 도면 대신, 3D지만 이미지 대신, 값비싼 뷰어 프로그램 대신!": "Ei vaikeaselkoisia piirustuksia, ei litteitä kuvia, ei kallista katseluohjelmaa.",
    "손쉬운 접근으로 직관적인 내용을 확인할 수 있습니다.": "Helppo avata, ja näkemäsi puhuu puolestaan.",
    "URL 링크 전달만으로 인터넷이 가능한 곳 어디서든 접속 가능합니다.": "Lähetä linkki – se avautuu kaikkialla, missä on verkkoyhteys.",
    "대면 미팅, VR 체험, 재질 변경 모두 가능합니다.": "Tapaamiset paikan päällä, VR-kierrokset ja materiaalivaihdot onnistuvat kaikki.",
    "지금 바로 확인하세요!": "Kokeile heti.",
    "집을, 혹은 건물을 짓는데 전문가의 도움 없이는 불가능합니다.": "Taloa tai muuta rakennusta ei voi rakentaa ilman asiantuntijan apua.",
    "나에게 꼭 맞는 집을 짓기에 필요한 각 분야 전문가들이 상시 대기 중입니다.": "Kaikkien alojen asiantuntijat auttavat sinua rakentamaan juuri sinulle sopivan kodin.",
    "건축설계, 인허가, 시공, 인테리어, 금융 등": "Arkkitehtuuri, luvat, rakentaminen, sisustus, rahoitus –",
    "해당 전문가에게 직접 물어보고 결정하세요.": "kysy suoraan oikealta asiantuntijalta ja päätä sitten.",
    "고객 맞춤의 이해하기 쉽고 단순한 용어로 변환하여 설명해 드립니다.": "Selitämme kaiken selkeästi ja sinun tarpeisiisi sovitettuna.",
    "부담 없이 언제든 연락주세요!": "Ota yhteyttä milloin tahansa – ilman sitoumuksia.",
    "대표 | 고호준": "Toimitusjohtaja | Ko Ho-jun",
    "대표이사 | 고 호 준": "Toimitusjohtaja | Ko Ho-jun",
    "개인정보 관리 책임자 | 이형우": "Tietosuojavastaava | Lee Hyoung-woo",
    "개인정보 관리 책임자 | 이 형 우": "Tietosuojavastaava | Lee Hyoung-woo",
    "사업자등록번호 | 469-81-03262": "Yritystunnus | 469-81-03262",
    "회사소개": "Tietoa meistä",
    "이용약관": "Käyttöehdot",
    "개인정보처리방침": "Tietosuojaseloste",
    "위치기반 서비스 이용약관": "Sijaintipalvelujen ehdot",
    "올바른 주소를 입력 혹은 클릭해주세요.": "Anna kelvollinen osoite tai valitse kohta kartalta.",
    "검색 결과가 없습니다.": "Tuloksia ei löytynyt.",
    "검색 결과 없음": "Ei tuloksia",
    "검색에 실패하였습니다.": "Haku epäonnistui.",
    "주소를 찾을 수 없습니다.": "Osoitetta ei löytynyt.",
    "주소 오류": "Osoitevirhe",
    "지오코딩 에러": "Geokoodausvirhe",
    "하천은 선택하실 수 없습니다.": "Jokea ei voi valita.",
    "도로는 선택하실 수 없습니다.": "Tietä ei voi valita.",
    "실거래가": "Kauppahinta",
    "지도를 탐색하여 토지를 선택하거나 주소를 검색해주세요.": "Siirrä karttaa ja valitse tontti tai hae osoitteella.",
    "신축할 필지를 찾아보세요!": "Etsi rakennustontti",
    "지적도": "Kiinteistökartta",
    "거리레이어": "Kadut (karttataso)",
    "전체화면": "Koko näyttö",
    "일반": "Perus",
    "위성": "Satelliitti",
    "로드뷰": "Katunäkymä",
    "반경": "Säde",
    "면적": "Pinta-ala",
    "거리": "Etäisyys",
    "건물 실거래가 조회 금액": "Kauppahintaväli",
    "확인": "Vahvista",
    "1억": "100 milj. ₩",
    "5억": "500 milj. ₩",
    "10억": "1 mrd. ₩",
    "30억": "3 mrd. ₩",
    "60억": "6 mrd. ₩",
    "아파트": "Kerrostalo",
    "오피스텔": "Officetel",
    "공장창고등": "Tehdas / varasto",
    "단독다가구": "Pientalo",
    "상업업무용": "Liike / toimisto",
    "연립다세대": "Rivitalo / pienkerrostalo",
    "토지": "Tontti",
    "토지정보": "Tontti",
    "건축정보": "Rakennus",
    "예상공사비": "Kustannukset",
    "토지평가": "Arviointi",
    "가격비교": "Hintakehitys",
    "시뮬레이션": "Simulaatio",
    "신축정보": "Uudisrakennus",
    "건물정보": "Rakennukset",
    "AI 분석": "AI-analyysi",
    "상세": "Lisätiedot",
    "개발제한구역으로": "Tontti on rakentamisrajoitusalueella (vihervyöhyke) –",
    "건축이 불가능한 토지입니다.": "sille ei saa rakentaa.",
    "토지 면적": "Tontin pinta-ala",
    "지목": "Maankäyttölaji",
    "용도": "Aluetyyppi",
    "건축가능용도": "Sallittu käyttö",
    "공시지가": "Maan arvo",
    "지형높이": "Maaston korkeus",
    "지형형상": "Tontin muoto",
    "데이터기준일자": "Tiedot päivitetty",
    "건축 면적": "Rakennettu ala",
    "연면적": "Kokonaisala",
    "건폐율": "Rakennusaste",
    "용적률": "Tehokkuusluku",
    "총액": "Yhteensä",
    "설계비": "Suunnittelukulut",
    "자재비": "Materiaalit",
    "인건비": "Työ",
    "경비": "Yleiskulut",
    "건물정보가 없습니다.": "Rakennustietoja ei ole saatavilla.",
    "건물정보 {n}": "Rakennus {n}",
    "건물명": "Rakennuksen nimi",
    "건물동명": "Rakennusosa",
    "건추물구조명": "Rakenne",
    "주도용도명": "Pääkäyttö",
    "건물높이": "Korkeus",
    "지상층수": "Kerrosluku",
    "지하층수": "Kellarikerrokset",
    "허가일자": "Lupapäivä",
    "총주차대수": "Pysäköintipaikat",
    "총주차장면적": "Pysäköintiala",
    "정보 없음": "Ei tietoja",
    "AI 평가 가치": "AI-arvio",
    "AI 분석 요약": "AI-yhteenveto",
    "{amount}원, {percent}%": "{amount} ₩, {percent} %",
    "내용을 불러오는중...": "Ladataan…",
    "가격 비교 정보가 없습니다.": "Hintatietoja ei ole saatavilla.",
    "건축 예정일": "Rakentamisen suunniteltu aloitus",
    "건축 용도": "Rakennuksen käyttö",
    "선택하세요": "Valitse",
    "시뮬레이션 중...": "Simuloidaan…",
    "시뮬레이션 하기": "Käynnistä simulaatio",
    "추천 구매 시기": "Paras ostoaika",
    "완공 예정일": "Arvioitu valmistuminen",
    "예상 수익률": "Odotettu tuotto",
    "AI 건축물/토지 찾기": "AI-haku: rakennukset ja tontit",
    "AI 분석을 불러오는 중입니다. 잠시만 기달려주세요.": "Ladataan AI-analyysiä. Hetki vain.",
    "AI 데이터 분석 중 오류가 발생했습니다.": "AI-analyysissä tapahtui virhe.",
    "주소 정보가 없습니다.": "Osoitetta ei ole valittu.",
    "건축 예정일은 YYYY.MM 형식으로 입력하고, 건축 용도를 선택해주세요.": "Anna rakentamisen suunniteltu aloitus muodossa VVVV.KK ja valitse rakennuksen käyttö.",
    "AI 시뮬레이션 중 오류가 발생했습니다.": "AI-simulaatiossa tapahtui virhe.",
    "전체": "Kaikki",
    "북마크를 등록해주세요!": "Ei vielä kirjanmerkkejä.",
    "대지면적": "Tontin pinta-ala",
    "견적 비교하기": "Vertaa kustannuksia",
    "새 리스트 추가": "Lisää uusi lista",
    "리스트는 최대 3개까지 입니다.": "Voit luoda enintään 3 listaa.",
    "새 리스트명을 입력해주세요": "Anna uuden listan nimi",
    "색상 선택": "Väri",
    "리스트 저장": "Tallenna lista",
    "토지의 별명을 입력해주세요.": "Anna tontille nimi.",
    "새 리스트를 추가해 주세요.": "Lisää ensin lista.",
    "메모": "Muistiinpano",
    "저장": "Tallenna",
    "건축용도 가능여부": "Sallitut käyttötarkoitukset",
    "건축가능": "Sallittu",
    "건축불가": "Ei sallittu",
    "건축제한": "Rajoitettu",
    "조건부가능": "Ehdollisesti sallittu",
    "[조건·제한·예외사항]": "[Ehdot ja rajoitukset]",
    "(조건·제한·예외사항 : {detail})": "(Ehdot / rajoitukset / poikkeukset: {detail})",
    "보다 자세한 내용은 토지이음에서 확인해주시길 바랍니다.": "Lisätietoja löydät Korean valtion Toji-Eum-maankäyttöpalvelusta.",
    "토지이음 바로가기": "Avaa Toji-Eum",
    "조건이 붙습니다. 전체 내용은 아래 토지이음에서 확인하세요.": "Ehtoja sovelletaan – koko teksti löytyy alta Toji-Eum-palvelusta.",
    "평": " pyeong",
    "(원/㎡)": "(KRW/m²)",
    "{n}대": "Autopaikat: {n}",
    "건축물사진": "Arkkitehtuurikuva",
    "프롭메이트는 지도 기반으로": "PROPMATE on karttapohjainen palvelu, joka tarjoaa",
    "토지 관련 모든 정보를 신속하고 정확하게 제공하는 전문 서비스를 자랑합니다.": "kaikki tonttitiedot nopeasti ja tarkasti.",
    "강력한 데이터베이스와 AI 기술을 바탕으로,": "Kattavan tietokannan ja tekoälyn avulla",
    "고객이 원하는 건물을 지을 수 있는 규모와 예상 비용을 정밀하게 예측합니다.": "ennustamme tarkasti, kuinka suuren rakennuksen voit rakentaa ja mitä se maksaa.",
    "또한, 건축 가능 용도에 따른 다양한 개발 옵션을 제시하며,": "Esittelemme myös kehitysvaihtoehtoja sallittujen käyttötarkoitusten mukaan",
    "끊임없이 발전하는 기술과 정보를 통해 고객이 가장 현명한 결정을 내릴 수 있도록 지원합니다.": "ja autamme jatkuvasti kehittyvän teknologian ja tiedon avulla sinua tekemään viisaimman päätöksen.",
    "항상 고객 만족을 최우선 가치로 삼으며,": "Tyytyväisyytesi on etusijalla kaikessa, mitä teemme,",
    "함께하는 모든 건축 과정에서 안도감과 신뢰를 제공하는 든든한 파트너가 되겠습니다.": "ja haluamme olla luotettava kumppani rakentamisen jokaisessa vaiheessa.",
    "프롭메이트와 함께라면,": "PROPMATEn kanssa",
    "혁신적인 기술과 신뢰할 수 있는 전문성을 통해 고객의 꿈을 현실로 만들어 드립니다.": "innovatiivinen teknologia ja luotettava asiantuntemus tekevät unelmastasi totta.",
    "IR파일이미지": "IR-aineisto",
    "기업소개서": "Yritysesite",
    "프롭메이트 대만 화면": "PROPMATE Taiwan -näkymä",
    "프롭메이트 대만 버전은 신주시(新竹市)를 시작으로 대만의 필지 정보를 지도 위에서 바로 확인할 수 있는 서비스입니다.": "PROPMATE Taiwanilla voit tarkastella Taiwanin tonttitietoja suoraan kartalla, aluksi Hsinchun kaupungissa.",
    "필지를 클릭하면 용도지역·건폐율·용적률과 건축 가능 규모를 보여주고,": "Tonttia napsauttamalla näet kaavoituksen, rakennusoikeuden, tehokkuusluvun ja rakennettavan laajuuden,",
    "실거래 정보와 AI 분석으로 예상 공사비까지 한 번에 살펴볼 수 있습니다.": "sekä toteutuneet kaupat ja tekoälyn arvion rakennuskustannuksista.",
    "대만 버전 바로가기": "Siirry PROPMATE Taiwaniin",
    "회사소개파일이미지": "Yritysesite (tiedosto)",
    "회사소개서 언어 선택": "Valitse esitteen kieli",
    "한국어": "Korea",
    "한국어 🇰🇷": "Korea 🇰🇷",
    "AI가 조건에 맞는 토지를 찾고 있습니다...": "Tekoäly etsii ehtojasi vastaavia tontteja…",
    "AI 검색이 완료되었습니다!": "AI-haku valmis.",
    "검색 중 오류가 발생했습니다. 다시 시도해주세요.": "Haussa tapahtui virhe. Yritä uudelleen.",
    "{region} 지역의 적합한 토지": "{region}: sopivat tontit",
    "현재 AI 서비스에 일시적인 문제가 발생했습니다. 부동산 전문가와 상담하시기 바랍니다.": "AI-palvelu ei ole tilapäisesti käytettävissä. Ota yhteyttä kiinteistöalan ammattilaiseen.",
    "원하는 토지/건축을 찾기 힘드신가요?": "Etkö löydä sopivaa tonttia tai rakennusta?",
    "AI 토지/건축물 찾기": "AI-haku: tontit ja rakennukset",
    "원하는 지역을 선택해주세요.": "Valitse haluamasi alueet.",
    "(최대 3개까지 선택 가능)": "(enintään 3)",
    "지역을 선택해주세요": "Valitse alue",
    "AI 토지/건축물 지역 선택 아이콘": "Alueen valinta",
    "예산안을 알려주세요.": "Kerro budjettisi.",
    "원하는 토지/건축물에 대해 설명해주세요.": "Kuvaile haluamaasi tonttia tai rakennusta.",
    "ex) 서울, 상업시설, 200평 이상, 10억~30억의 예산안\n'단독주택을 짓고 싶은데 조망이 좋고 조용한 동네면 좋겠어.'": "esim. Soul, liiketila, vähintään 200 pyeongia, budjetti 1–3 mrd. ₩\n”Haluan rakentaa omakotitalon rauhalliselle paikalle, josta on hyvät näkymät.”",
    "검색 중...": "Haetaan…",
    "검색하기": "Hae",
    "총 {n}건의 토지를 찾았어요!": "Sopivia tontteja: {n}",
    "접기": "Piilota tiedot",
    "상세 보기": "Näytä tiedot",
    "AI 추천 이유": "Miksi tekoäly suosittelee tätä",
    "다시하기": "Aloita alusta",
    "서울": "Soul",
    "부산": "Busan",
    "대구": "Daegu",
    "인천": "Incheon",
    "광주": "Gwangju",
    "대전": "Daejeon",
    "울산": "Ulsan",
    "세종": "Sejong",
    "경기도": "Gyeonggi-do",
    "강원도": "Gangwon-do",
    "충청북도": "Chungcheongbuk-do",
    "충청남도": "Chungcheongnam-do",
    "전라북도": "Jeollabuk-do",
    "전라남도": "Jeollanam-do",
    "경상북도": "Gyeongsangbuk-do",
    "경상남도": "Gyeongsangnam-do",
    "제주도": "Jeju-do",
    "견적 비교할 토지들을 선택해주세요!": "Valitse vertailtavat tontit.",
    "견적 비교를 위해 데이터를 불러오는 중입니다.": "Ladataan vertailutietoja…",
    "예상 공사비": "Arvioidut rakennuskustannukset",
    "{purpose} 건축 불가": "{purpose}: ei sallittu",
    "건축 가능 용도": "Sallitut käyttötarkoitukset",
    "단독주택": "Omakotitalo",
    "공동주택": "Kerros- ja rivitalot",
    "제1종 근린생활시설": "Lähipalvelut (lk. 1)",
    "제2종 근린생활시설": "Lähipalvelut (lk. 2)",
    "문화 및 집회시설": "Kulttuuri ja kokoontuminen",
    "판매시설": "Kauppa",
    "운동시설": "Urheilu",
    "숙박시설": "Majoitus",
    "의료시설": "Terveydenhuolto",
    "교육연구시설": "Koulutus ja tutkimus",
    "노유자시설": "Vanhus- ja lastenhoito",
    "업무시설": "Toimisto",
    "종교시설": "Uskonnolliset tilat",
    "컨설팅 받고자 하는 항목들을 선택해주세요. (중복선택 가능)": "Valitse, mistä haluat neuvontaa. (Voit valita useita.)",
    "컨설팅 받고자하는 건축용도를 입력해주세요. ex)단독주택/다가구주택": "Anna rakennuksen käyttötarkoitus, josta haluat neuvontaa, esim. omakotitalo / moniasuntoinen pientalo",
    "컨설팅 접수가 완료 되었습니다. 영업일 기준 5일이내로 답변 드리겠습니다. 모든 접수는 순차적으로 답변 드립니다. 감사합니다.": "Pyyntösi on vastaanotettu. Vastaamme 5 arkipäivän kuluessa saapumisjärjestyksessä. Kiitos.",
    "컨설팅 문의를 보냈습니다.": "Neuvontapyyntösi on lähetetty.",
    "중복선택 가능": "Voit valita useita",
    "ex)단독주택/다가구주택": "esim. omakotitalo / moniasuntoinen pientalo",
    "컨설팅 항목 선택": "Mistä tarvitset neuvontaa?",
    "건축 용도 선택": "Rakennuksen käyttö",
    "건축예산": "Budjetti",
    "상세 문의": "Kysymyksesi",
    "컨설팅 받고자 하는 항목들에 대한 설명을 입력해주세요.\r\n \r\n \r\nex)  가지고 있는 땅에 단독 주택을 짓고 싶어요. 자금과 시간이 얼마나 드는지 알고 싶어요.": "Kerro tarkemmin, mitä tarvitset.\r\n \r\n \r\nesim.  Haluan rakentaa omakotitalon omistamalleni tontille. Haluaisin tietää, mitä se maksaa ja kuinka kauan se kestää.",
    "현재 보고 있는 토지": "Katselemani tontti",
    "설계 / 인허가": "Suunnittelu / luvat",
    "시공": "Rakentaminen",
    "인테리어": "Sisustus",
    "예상 공사비 / 예상소요기간": "Kustannusarvio / aikataulu",
    "토지 매입": "Tontin osto",
    "기타 (상세문의 작성)": "Muu (kirjoita alle)",
    "3억": "300 milj. ₩",
    "6억": "600 milj. ₩",
    "20억": "2 mrd. ₩",
    "주소 | 서울시 관악구 문성로 199-1 2층": "Osoite | 2. krs, 199-1 Munseong-ro, Gwanak-gu, Soul",
    "사업자등록번호 | 628-40-00876": "Yritystunnus | 628-40-00876",
    "위치기반서비스": "Sijaintipalvelut",
    "프로모션 정보 수신": "Markkinointiviestit",
    "로그인": "Kirjaudu",
    "로그인박스": "Kirjautuminen",
    "회원가입": "Rekisteröidy",
    "회원가입박스": "Rekisteröityminen",
    "아이디 찾기": "Unohtunut tunnus",
    "아이디찾기": "Unohtunut tunnus",
    "비밀번호 재설정": "Vaihda salasana",
    "환영합니다!": "Tervetuloa!",
    "집을 짓기 위한 새로운 여정,": "Uusi matka kohti omaa kotia –",
    "프롭메이트와 함께 하세요!": "aloita se PROPMATEn kanssa.",
    "아이디 와 비밀번호를 모두 입력해주세요.": "Anna sekä tunnus että salasana.",
    "프롭메이트 아이디 입력": "PROPMATE-tunnus",
    "프롭메이트 비밀번호 입력": "PROPMATE-salasana",
    "카카오로그인버튼": "Kakao-kirjautumispainike",
    "카카오로그인": "Kirjaudu Kakaolla",
    "네이버로그인버튼": "Naver-kirjautumispainike",
    "네이버로그인": "Kirjaudu Naverilla",
    "이메일을 입력해주세요.": "Anna sähköpostiosoitteesi.",
    "이름(기업명)을 입력해주세요.": "Anna nimesi (tai yrityksen nimi).",
    "전화번호를 입력해주세요.": "Anna puhelinnumerosi.",
    "비밀번호를 입력해주세요.": "Anna salasana.",
    "아이디를 입력해주세요.": "Anna käyttäjätunnus.",
    "회원가입이 완료되었습니다.": "Tilisi on luotu.",
    "아이디 입력": "Tunnus",
    "영문 대소문자와 숫자 4~12자리": "4–12 merkkiä (a–z, A–Z, 0–9)",
    "비밀번호 입력": "Salasana",
    "영문 대소문자와 숫자 8~20자리": "8–20 merkkiä (a–z, A–Z, 0–9)",
    "비밀번호 확인란을 입력해주세요.": "Vahvista salasanasi.",
    "비밀번호 확인": "Vahvista salasana",
    "비밀번호가 일치하지 않습니다.": "Salasanat eivät täsmää.",
    "전화번호 입력 (숫자만)": "Puhelinnumero (vain numerot)",
    "이름(기업명) 입력": "Nimi (tai yrityksen nimi)",
    "이메일 입력": "Sähköposti",
    "이메일 형식으로 입력해주세요.": "Anna kelvollinen sähköpostiosoite.",
    "선택": "Valinnainen",
    "남자": "Mies",
    "여자": "Nainen",
    "년(4자)": "Vuosi (4 numeroa)",
    "--월": "-- Kuukausi",
    "1월": "Tammikuu",
    "2월": "Helmikuu",
    "3월": "Maaliskuu",
    "4월": "Huhtikuu",
    "5월": "Toukokuu",
    "6월": "Kesäkuu",
    "7월": "Heinäkuu",
    "8월": "Elokuu",
    "9월": "Syyskuu",
    "10월": "Lokakuu",
    "11월": "Marraskuu",
    "12월": "Joulukuu",
    "일": "Päivä",
    "직업 선택": "Valitse ammatti",
    "예비 건축주": "Tuleva rakennuttaja",
    "건축업 종사자": "Rakennusalan ammattilainen",
    "프롭메이트 정보수집에 모두 동의합니다.": "Hyväksyn kaikki ehdot.",
    "프롭메이트 이용약관 동의": "Hyväksyn PROPMATEn käyttöehdot",
    "필수": "Pakollinen",
    "자세히보기": "Lue lisää",
    "개인정보 수집 및 이용 동의": "Hyväksyn henkilötietojen keräämisen ja käytön",
    "위치기반서비스 이용약관 동의": "Hyväksyn sijaintipalvelujen ehdot",
    "프로모션 정보 수신 동의": "Hyväksyn markkinointiviestien vastaanottamisen",
    "가입한 이메일 입력": "Rekisteröitymisessä käytetty sähköposti",
    "가입한 아이디 입력": "Rekisteröitymisessä käytetty tunnus",
    "이메일에 인증번호를 보냈습니다.": "Lähetimme vahvistuskoodin sähköpostiisi.",
    "인증완료.": "Vahvistettu.",
    "인증에 실패했습니다. 다시 인증요청 해주시길 바랍니다.": "Vahvistus epäonnistui. Pyydä uusi koodi.",
    "비밀번호 변경완료": "Salasanasi on vaihdettu.",
    "인증요청": "Lähetä koodi",
    "인증번호": "Vahvistuskoodi",
    "인증번호 입력": "Anna koodi",
    "인증확인": "Vahvista",
    "입력안함": "Ei annettu",
    "내 정보": "Oma profiili",
    "정보 수정": "Muokkaa profiilia",
    "내정보 수정 박스": "Profiilin muokkaus",
    "수정완료": "Tallenna",
    "취소": "Peruuta",
    "닉네임변경": "Vaihda nimimerkki",
    "닉네임변경완료버튼": "Vahvista nimimerkin vaihto",
    "이메일을 입력해 주세요.": "Anna sähköpostiosoitteesi.",
    "핸드폰 번호를 입력해 주세요.": "Anna matkapuhelinnumerosi.",
    "이름을 입력해 주세요.": "Anna nimesi.",
    "성별을 선택해 주세요.": "Valitse sukupuolesi.",
    "생년월일을 입력해 주세요.": "Anna syntymäaikasi.",
    "직업을 선택해 주세요.": "Valitse ammattisi.",
    "직업을 선택해 주세요": "Valitse ammattisi",
    "개인정보 이용내역": "Henkilötietojen käyttö",
    "조회": "Näytä",
    "북마크": "Kirjanmerkit",
    "대지면적  :": "Tontin pinta-ala:",
    "지도페이지로이동": "Siirry karttaan",
    "지도에서 북마크를 등록해주세요!": "Lisää kirjanmerkkejä kartalta.",
    "지도 바로가기": "Avaa kartta",
    "삭제하기": "Poista",
    "수정하기": "Muokkaa",
    "뉴스를 불러오는 중...": "Ladataan uutisia…",
    "등록된 뉴스가 없습니다.": "Ei vielä uutisia.",
    "이전": "Edellinen",
    "다음": "Seuraava",
    "공시지가 (만원/㎡)": "Virallinen maan arvo (10 000 KRW/m²)",
    "5개년 공시지가 그래프": "Virallinen maan arvo, viimeiset 5 vuotta",
    "AI 예측 5년 후 평당 가격 (단위: 원)": "AI:n 5 vuoden ennuste – hinta per pyeong (KRW)",
    "AI 평당 가격 예측 그래프": "AI-ennuste: hinta per pyeong",
    "{amount}원": "{amount} ₩",
    "{amount}원 ({percent}%)": "{amount} ₩ ({percent} %)",
    "변동 없음": "Ei muutosta",
    "최저가": "Alin",
    "최고가": "Ylin",
    "토지가격": "Maan hinta",
    "투자가치": "Sijoitusarvo",
    "법적 규제": "Sääntely",
    "소음": "Melu",
    "인구 규모": "Väestö",
    "교통 및 접근성": "Liikenne ja saavutettavuus",
    "지형 및 토양": "Maasto ja maaperä",
    "편의시설": "Palvelut",
    "인프라 및 공공시설": "Infrastruktuuri",
    "평가": "Arviointi",
    "{n}점": "{n} p",
    "3D웹사이트 보러가기": "Siirry 3D-sivustolle",
    "게시글을 작성해주세요": "Kirjoita julkaisu",
    "건축의 시작이,\n더 이상 전문가만의 영역이 아니길 바란다.": "Toivon, ettei rakentamisen aloittaminen\nolisi enää vain asiantuntijoiden asia.",
    "#건축가 #창업가 #유튜버": "#arkkitehti #yrittäjä #tubettaja",
    "나는 방향을 설계하고,\n팀은 파도를 만든다.": "Minä näytän suunnan,\ntiimi tekee aallot.",
    "#분위기메이커 #햇살캐 #꺄르르": "#tunnelmanluoja #auringonpaiste #kikatus",
    "설계는 정답이 없지만 오답은 있다.": "Suunnittelussa ei ole oikeaa vastausta, mutta vääriä on.",
    "#건축가 #궁수 #클라이머": "#arkkitehti #jousiampuja #kiipeilijä",
    "불가능한 개발은 없다.\n노력이 필요할 뿐.": "Mikään ei ole mahdotonta koodata.\nSe vaatii vain työtä.",
    "#풀스택 #천재개발자 #플러팅장인": "#fullstack #nerokoodari #flirttimestari",
    "모든 것은 ‘기획’으로 시작된다.": "Kaikki alkaa suunnittelusta.",
    "#기획 #감정미적분기 #유빈씨,,바빠요?": "#suunnittelu #tunnelaskenta #yubinOnkoKiire?",
    "버그보다 골절이 먼저 왔다.": "Murtuma tuli ennen bugia.",
    "#풀스택 #술자바(Sul.js) #손가락404": "#fullstack #Sul.js #sormi404",
    "데이터는 쿨하게,\n분석은 뜨겁게.": "Data viileästi,\nanalyysi kuumana.",
    "#데이터개발자 #동자승 #오픈런러": "#datakehittäjä #pikkumunkki #avausjonottaja",
    "오류는 고쳐도,\n자세는 못 고친다.": "Virheet korjaan,\nryhtiäni en.",
    "#풀스택 #허리404 #래블래용": "#fullstack #selkä404 #raeblaeyong",
    "디자인은 디테일,\n회식은 타이밍.": "Design on yksityiskohtia,\nillallinen ajoitusta.",
    "#디자이너 #회식탐지기 #피그마의광대": "#suunnittelija #illallistutka #figmaklovni",
    "투명하고 똑똑한 IT 건축 플랫폼 '프롭메이트' 부동산 개발의 새로운 패러다임 열다": "PROPMATE, läpinäkyvä ja älykäs rakentamisen IT-alusta, avaa uuden aikakauden kiinteistökehityksessä",
    "프롭메이트, '2024 대한민국 지식재산대전'에서 AI 토지정보 제공 시스템 선봬": "PROPMATE esittelee tekoälypohjaisen tonttitietojärjestelmänsä Korea Intellectual Property Exhibition 2024 -tapahtumassa",
    "프롭메이트, 'NIPA 지역 성과보고회' 성공적 참여": "PROPMATE osallistuu NIPA:n alueelliseen tulostilaisuuteen",
    "프롭메이트, AIoT 국제전시회에서 혁신적 솔루션을 선보이다.": "PROPMATE esittelee innovatiivisen ratkaisunsa AIoT International Exhibition -messuilla",
    "프롭메이트, 2024 AIoT 국제전시회 참가... 토지 정보 제공 시스템·3D 가상 시뮬레이션 기술 알린다": "PROPMATE mukana AIoT International Exhibition 2024 -messuilla esittelemässä tonttitietojärjestelmää ja 3D-simulaatioteknologiaa",
    "대": "Rakennusmaa",
    "대지": "Rakennusmaa",
    "전": "Pelto",
    "답": "Riisipelto",
    "과수원": "Hedelmätarha",
    "목장용지": "Laidun",
    "임야": "Metsä",
    "광천지": "Kivennäislähde",
    "염전": "Suola-allas",
    "공장용지": "Teollisuustontti",
    "학교용지": "Koulutontti",
    "주차장": "Pysäköintialue",
    "주유소용지": "Huoltoasematontti",
    "창고용지": "Varastotontti",
    "도로": "Tie",
    "철도용지": "Rautatiealue",
    "제방": "Penger",
    "하천": "Joki",
    "구거": "Oja",
    "유지": "Allas",
    "양어장": "Kalankasvattamo",
    "수도용지": "Vesilaitosalue",
    "공원": "Puisto",
    "체육용지": "Urheilualue",
    "유원지": "Huvipuisto",
    "종교용지": "Uskonnollinen alue",
    "사적지": "Historiallinen kohde",
    "묘지": "Hautausmaa",
    "잡종지": "Muu maa-alue",
    "제1종전용주거지역": "Pelkän asumisen alue, tyyppi 1",
    "제2종전용주거지역": "Pelkän asumisen alue, tyyppi 2",
    "제1종일반주거지역": "Yleinen asuinalue, tyyppi 1",
    "제2종일반주거지역": "Yleinen asuinalue, tyyppi 2",
    "제3종일반주거지역": "Yleinen asuinalue, tyyppi 3",
    "준주거지역": "Sekoittunut asuinalue",
    "중심상업지역": "Keskustan liikealue",
    "일반상업지역": "Yleinen liikealue",
    "근린상업지역": "Lähiliikealue",
    "유통상업지역": "Jakelu- ja kauppa-alue",
    "전용공업지역": "Raskaan teollisuuden alue",
    "일반공업지역": "Yleinen teollisuusalue",
    "준공업지역": "Sekoittunut teollisuusalue",
    "보전녹지지역": "Suojeltu viheralue",
    "생산녹지지역": "Tuotannollinen viheralue",
    "자연녹지지역": "Luonnontilainen viheralue",
    "보전관리지역": "Suojeltu haja-asutusalue",
    "생산관리지역": "Tuotannollinen haja-asutusalue",
    "계획관리지역": "Suunniteltu haja-asutusalue",
    "농림지역": "Maa- ja metsätalousalue",
    "자연환경보전지역": "Luonnonsuojelualue",
    "개발제한구역": "Rakentamisrajoitusalue (vihervyöhyke)",
    "정방형": "Neliö",
    "가장형": "Suorakaide (leveä)",
    "가로장방형": "Suorakaide (leveä)",
    "세로장방형": "Suorakaide (syvä)",
    "사다리형": "Puolisuunnikas",
    "부정형": "Epäsäännöllinen",
    "자루형": "Takatontti",
    "삼각형": "Kolmio",
    "역삼각형": "Käänteinen kolmio",
    "수련시설": "Nuorisokoulutustila",
    "창고시설": "Varasto",
    "위험물 저장 및 처리 시설": "Vaaralliset aineet",
    "자동차 관련 시설": "Ajoneuvopalvelut",
    "동물 및 식물 관련 시설": "Eläinsuojat ja kasvihuoneet",
    "교정 및 군사 시설": "Vankila- ja sotilastilat",
    "방송통신시설": "Lähetys- ja tietoliikennetilat",
    "묘지 관련 시설": "Hautauspalvelutilat",
    "결혼상담소": "Avioliittovälitys",
    "고등학교": "Lukio",
    "골프연습장": "Golfin harjoitusalue",
    "골프장": "Golfkenttä",
    "공공도서관": "Yleinen kirjasto",
    "공관": "Virka-asunto",
    "공중화장실": "Yleinen WC",
    "공회당": "Kokoontumistila",
    "과학관": "Tiedekeskus",
    "교습소": "Tukiopetuskeskus",
    "교회": "Kirkko",
    "구기장": "Pallokenttä",
    "국방시설": "Puolustuslaitos",
    "군사시설": "Sotilaslaitos",
    "궁도장": "Jousiammuntarata",
    "극장": "Teatteri",
    "근로복지시설": "Työntekijöiden hyvinvointitila",
    "금융업소": "Rahoituslaitos",
    "기념관": "Muistomuseo",
    "기도원": "Rukouskeskus",
    "기숙사": "Asuntola",
    "기원": "Baduk-kerho",
    "노래연습장": "Karaokepaikka",
    "노인복지시설": "Vanhustenpalvelutila",
    "놀이형시설": "Leikkitila",
    "농수산물공판장": "Maa- ja kalatalouden huutokauppa",
    "농수산물도매시장": "Maa- ja kalatalouden tukkutori",
    "다가구주택": "Moniasuntoinen pientalo",
    "다세대주택": "Pienkerrostalo",
    "다중생활시설": "Pienhuoneasuntola",
    "다중주택": "Soluasuntotalo",
    "당구장": "Biljardisali",
    "대규모점포": "Vähittäiskaupan suuryksikkö",
    "대피소": "Väestönsuoja",
    "대학교": "Yliopisto",
    "데이터센터": "Datakeskus",
    "도시가스배관시설": "Kaupunkikaasun putkistolaitos",
    "독서실": "Itseopiskelutila",
    "동물미용실": "Lemmikkien trimmaamo",
    "동물병원": "Eläinlääkäriasema",
    "동물원": "Eläintarha",
    "롤러스케이트장": "Rullaluistelurata",
    "마을공동구판장": "Kyläosuuskauppa",
    "마을공동작업소": "Kyläpaja",
    "마을회관": "Kylätalo",
    "목욕장": "Yleinen sauna",
    "문화관": "Kulttuurikeskus",
    "미술관": "Taidemuseo",
    "미용원": "Kauneushoitola",
    "박람회장": "Näyttelyhalli",
    "박물관": "Museo",
    "방송국": "Radio- ja tv-asema",
    "변전소": "Sähköasema",
    "보건소": "Terveyskeskus",
    "복합유통게임제공업소": "Pelihalli",
    "볼링장": "Keilahalli",
    "봉안당(奉安堂)": "Kolumbaario",
    "부동산중개사무소": "Kiinteistönvälitys",
    "비디오물감상실": "Videokatseluhuone",
    "비디오물소극장": "Pieni videoteatteri",
    "사격장": "Ampumarata",
    "사당": "Pyhäkkö",
    "사무소": "Toimisto",
    "사진관": "Valokuvaamo",
    "사찰": "Buddhalainen temppeli",
    "사회복지시설": "Sosiaalipalvelutila",
    "산업전시장": "Teollisuusnäyttelyhalli",
    "산후조리원": "Lapsivuodeajan hoitokoti",
    "상점": "Myymälä",
    "서점": "Kirjakauppa",
    "서커스장": "Sirkusalue",
    "성당": "Katolinen kirkko",
    "세차장": "Autopesula",
    "세탁소": "Pesula",
    "소방서": "Paloasema",
    "수녀원": "Nunnaluostari",
    "수도원": "Luostari",
    "수리점": "Korjaamo",
    "수영장": "Uimahalli",
    "수족관": "Akvaario",
    "스케이트장": "Luistinrata",
    "승마장": "Ratsastuskenttä",
    "식물원": "Kasvitieteellinen puutarha",
    "실내낚시터": "Sisäkalastusallas",
    "아동복지시설": "Lastensuojelulaitos",
    "안마원": "Hierontahoitola",
    "양수장": "Pumppaamo",
    "어린이집": "Päiväkoti",
    "에어로빅장": "Aerobicstudio",
    "연구소": "Tutkimuslaitos",
    "연립주택": "Rivitalo",
    "연수원": "Koulutuskeskus",
    "연예장": "Viihdepaikka",
    "영화관": "Elokuvateatteri",
    "예식장": "Juhlasali",
    "요양병원": "Pitkäaikaissairaala",
    "우체국": "Posti",
    "유스호스텔": "Retkeilymaja",
    "유치원": "Lastentarha",
    "육상장": "Yleisurheilukenttä",
    "음악당": "Konserttitalo",
    "의원": "Lääkäriasema",
    "이용원": "Parturi",
    "인터넷컴퓨터게임시설제공업소": "Internetkahvila",
    "일반음식점": "Ravintola",
    "자동차영업소": "Autoliike",
    "장의사": "Hautaustoimisto",
    "전문대학": "Ammattikorkeakoulu",
    "전신전화국": "Teleasema",
    "접골원": "Jäsenkorjaamo",
    "정수장": "Vedenpuhdistamo",
    "정신병원": "Psykiatrinen sairaala",
    "제과점": "Leipomo",
    "제실": "Esi-isien pyhäkkö",
    "제조업소": "Valmistuspaja",
    "조산원": "Kätilöklinikka",
    "종묘배양시설": "Taimikasvatuslaitos",
    "종합병원": "Sairaala",
    "주유소": "Huoltoasema",
    "중학교": "Yläkoulu",
    "지구대": "Poliisiasema",
    "지역아동센터": "Lasten lähikeskus",
    "지역자치센터": "Asukaspalvelukeskus",
    "직업훈련소": "Ammatillinen koulutuskeskus",
    "차고": "Autotalli",
    "청소년게임제공업소": "Nuorten pelihalli",
    "청소년문화의집": "Nuorten kulttuuritalo",
    "청소년수련관": "Nuorisotalo",
    "청소년수련원": "Nuorisokeskus",
    "청소년야영장": "Nuorten leirintäalue",
    "청소년특화시설": "Erikoistunut nuorisotila",
    "체력단련장": "Kuntosali",
    "체육관": "Liikuntahalli",
    "체육도장": "Kamppailulajisali",
    "체험관": "Elämyskeskus",
    "초등학교": "Alakoulu",
    "총포판매소": "Aseliike",
    "촬영소": "Elokuvastudio",
    "출판사": "Kustantamo",
    "치과병원": "Hammassairaala",
    "치과의원": "Hammaslääkäriasema",
    "침술원": "Akupunktioklinikka",
    "탁구장": "Pöytätennishalli",
    "테니스장": "Tenniskenttä",
    "파출소": "Poliisipiste",
    "표구점": "Kehystämö",
    "하역장": "Lastauspiha",
    "학원": "Valmennuskoulu",
    "한방병원": "Perinnelääketieteen sairaala",
    "한의원": "Perinnelääketieteen klinikka",
    "회의장": "Konferenssisali",
    "휴게음식점": "Kahvila / pikaruokala",
    "Log In": "Kirjaudu",
    "Log Out": "Kirjaudu ulos",
    "About": "Tietoa meistä",
    "Service": "Palvelut",
    "Propmate Map": "Propmate Map",
    "People": "Tiimi",
    "News": "Uutiset",
    "History": "Historia",
    "My page": "Oma sivu",
    "ID": "Tunnus",
    "Password": "Salasana",
    "Phone Number": "Puhelinnumero",
    "PhoneNumber": "Puhelinnumero",
    "Phone": "Puhelin",
    "Email": "Sähköposti",
    "EMAIL": "SÄHKÖPOSTI",
    "Gender": "Sukupuoli",
    "Birthday": "Syntymäaika",
    "Occupational": "Ammatti",
    "Occupation": "Ammatti",
    "Download": "Lataa",
    "Introduction": "Esittely",
    "English": "Englanti",
    "SCORE": "PISTEET",
    "Loading...": "Ladataan…",
};

export default fi;
